import { render, staticRenderFns } from "./component-b171a7fa.vue?vue&type=template&id=5f568017&scoped=true&"
import script from "./component-b171a7fa.vue?vue&type=script&lang=js&"
export * from "./component-b171a7fa.vue?vue&type=script&lang=js&"
import style0 from "./component-b171a7fa.vue?vue&type=style&index=0&id=5f568017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f568017",
  null
  
)

export default component.exports